import { AstraCallout } from '~/astra'

const types = {
    noSurgeons: { color: 'default' as const, text: 'Ingen kirurger er satt opp. Viser hele ventelisten for operasjonskategorien.' },
    error: { color: 'critical' as const, text: 'En feil oppstod under lasting av ventelister. Vennligst prøv å oppdatere siden.' },
    noAccess: { color: 'caution' as const, text: 'Ventelistedata mangler fordi du ikke har tilgang til pasientinformasjon.' },
    restrictedAccess: { color: 'caution' as const, text: 'Ventelistedata kan være begrenset fordi du ikke har tilgang til all pasientinformasjon.' },
    noPredictionsAllDepartments: {
        color: 'caution' as const,
        text: 'Kan ikke vise predikert venteliste for alle avdelinger. Velg en avdeling for å vise ventelisteprediksjon.',
    },
    noPredictionsAllSpecialities: {
        color: 'caution' as const,
        text: 'Kan ikke vise predikert venteliste for alle fagområder. Spesifiser enkelte fagområder for å vise ventelisteprediksjon.',
    },
    noPredictionsSameOrPastMonth: { color: 'caution' as const, text: 'Kan ikke vise predikert venteliste for tidligere eller inneværende måned.' },
}

export type WaitingListCalloutType = keyof typeof types

type Props = {
    type: WaitingListCalloutType
}

export const WaitingListCallout = ({ type }: Props) => {
    const { color, text } = types[type]

    return <AstraCallout color={color} text={text} />
}
